import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ITEM_ICONS = [
    "fa-solid fa-kit-medical",
    "fa-solid fa-truck-medical",
    "fa-solid fa-briefcase-medical",
    "fa-solid fa-capsules",
    "fa-solid fa-pills",
    "fa-solid fa-person-rays",
];

const RESPONSIBILITIES_ITEMS = [
    { title: "Dispensing Medications", desc: "Ensuring the safe and accurate distribution of prescribed medicines to patients while providing proper dosage instructions" },
    { title: "Patient Counseling", desc: "Educating customers about their medications, potential side effects, and interactions to promote safe and effective use." },
    { title: "Health & Wellness Advice", desc: "Offering guidance on managing chronic conditions, lifestyle improvements, and over-the-counter medication recommendations." },
    { title: "Medication Management", desc: "Monitoring prescriptions to prevent harmful drug interactions, ensuring compliance, and assisting with medication refills" },
    { title: "Over-the-Counter Assistance", desc: "Helping customers choose the right non-prescription medications for common ailments and providing usage guidance." },
    { title: "Immunization Services", desc: "Administering vaccines, offering immunization advice, and ensuring compliance with health regulations for disease prevention." },
];

const BANNER = {
    heading: "Improving Health With Best Medicines",
    description: "Elevate your health with our expert advice and personalized care. We're here to support you on your health journey.",
    buttonText: "Contact Us",
    buttonLink: "/contact",
    imageURL: "https://i.postimg.cc/c422tG7j/pharmacist.png",
};

const HERO_IMAGE = "https://i.postimg.cc/2j2f6tKV/nurse1.png";

const ResponsibilitiesPage = () => {

    useEffect(() => {
        document.title = "Responsibilities | dawaacare";
    }, [])

    return (
        <div>
            <Header />
            <main className="resp-page">

                {/* ── Top: Responsibilities Grid ── */}
                <section className="resp-section">
                    <div className="resp-image-panel" data-aos="zoom-in">
                        <div className="resp-img-box">
                            <img src={HERO_IMAGE} alt="Pharmacist" className="resp-img" />
                        </div>
                    </div>

                    <div className="resp-content" data-aos="zoom-in">
                        <h2 className="resp-heading">
                            Our <span className="resp-heading-red">Responsibilities</span>
                        </h2>
                        <div className="resp-grid">
                            {RESPONSIBILITIES_ITEMS.map((item, i) => (
                                <div className="resp-item" key={i}>
                                    <div className="resp-icon-row">
                                        <span className="resp-icon-badge">
                                            <i className={ITEM_ICONS[i]}></i>
                                        </span>
                                        <h3 className="resp-item-title">{item.title}</h3>
                                    </div>
                                    <p className="resp-item-desc">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ── Bottom: Pharmacist Banner ── */}
                <section className="resp-banner" data-aos="fade-up">
                    <div className="resp-banner-content">
                        <h2 className="resp-banner-heading">{BANNER.heading}</h2>
                        <p className="resp-banner-desc">{BANNER.description}</p>
                        <div className="resp-banner-btns">
                            <a href={BANNER.buttonLink} className="resp-banner-btn">
                                {BANNER.buttonText}
                            </a>
                        </div>
                    </div>
                    <div className="resp-banner-img-wrap">
                        <img
                            src={BANNER.imageURL}
                            alt="Pharmacist"
                            className="resp-banner-img"
                        />
                    </div>
                </section>

            </main>
            <Footer />
        </div>
    );
};

export default ResponsibilitiesPage;
